
import { defineComponent, onMounted, ref } from "vue";
import token_service from "@/services/token_service";
import NotFound from "@/pages/404NotFound.vue";
import { getNodeEnv } from "./core/helpers";
import { useRoute } from "vue-router";
import CustomLogoLoader from "./components/CustomLogoLoader.vue";

console.log('NODE_ENV', process.env.VUE_APP_NODE_ENV)

export default defineComponent({

  name: "App",
  // eslint-disable-next-line no-mixed-spaces-and-tabs
  setup() {
    const route = useRoute()
  },
  components: {
    CustomLogoLoader,
  },
  data() {
    const node_env = ref('')

    onMounted(() => {
      node_env.value = getNodeEnv()
      console.log(node_env.value)
    })
    return {
      renderComponent: true,
      loading: true,
      node_env
    };
  },
  computed: {
    picUrl() {
      return (
        localStorage.getItem("picUrl") ||
        "https://cdn.pixabay.com/photo/2013/07/13/12/07/avatar-159236_1280.png"
      );
    },
    firstName() {
      return localStorage.getItem("first_name") || "GUEST";
    },
    isAgency() {
      //return true;
      return token_service.getUser()?.role === "AGENCY";
    },
  },

  methods: {
    setLoading(value: boolean) {
      this.loading = value;
    },
    toggle(): void {
      var sidebar = document.querySelector("#sidebar");
      var container = document.querySelector(".my-container");
      sidebar?.classList.toggle("active-nav");
      container?.classList.toggle("active-cont");
    },
    logout() {
      token_service.removeUser();
      localStorage.removeItem('picUrl')
      localStorage.removeItem('first_name');
      this.$router.push("/signin").then(() => {
        this.loading = true;
      });
    },
    forceRerender() {
      // Remove my-component from the DOM
      this.renderComponent = false;
      this.$nextTick(() => {
        // Add the component back in
        this.renderComponent = true;
      });
    },
  },
});
